import ProjectActivationConfigContent from './ProjectActivationConfigContent'

export default ProjectActivationConfigContent
